require('ta-semantic-ui/semantic/dist/components/header.css');
require('ta-semantic-ui/semantic/dist/components/divider.css');
require('./storyhead.styl');

import React from 'react';
import scrollDownImage from './imgs/scrollDown.svg';

class Storyhead extends React.Component {

  constructor(props) {
    super(props)


    this.state = ({
      height: this.props.height
    })
  }

  render() {
    return (

      <div
        className='storyhead wrapper'
      >

        <section
          className='storyhead background image'
          style={{
            height: this.state.height
          }}
        >

          <div
            className='intro-text'
          >

            <h2 className='ui header'>
              Plötzlich arm in der reichen Stadt
            </h2>

            <div
              className='lead'
            >

            <h4
              className='ui horizontal inverted divider'
            >

              Patrice Siegrist

            </h4>
              In Zürich sind Zehntausende Menschen von Armut betroffen. Sie werden kaum wahrgenommen. Oliver ist einer von ihnen – eine Geschichte eines Abstiegs.
            </div>

            <div
              className='scroll-down-wrapper'
            >

              <img
                src={scrollDownImage}
                width='100px'
                className='scroll-animation'
              />

            </div>

          </div>

        </section>

      </div>

    );
  }
}

Storyhead.defaultProps = {};

Storyhead.propTypes = {
  height: React.PropTypes.number
}

export default Storyhead;



// WEBPACK FOOTER //
// ./src/components/storyhead/Storyhead.js